module.exports = "<ul class=\"list-group box-shadow cta-list\" style=\"border: 1px, solid, black\"><li class=\"list-group-item\" *ngIf=\"this.formManager.getService() =='images'\"><a (click)=\"getLatest()\">get latest</a></li><li class=\"list-group-item\"><a (click)=\"getList()\">filter</a></li><li class=\"list-group-item\"><input type=\"text\"></li></ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sidebar-cta/sidebar-cta.component.pug
// module id = 1110
// module chunks = 1